import React, { useState, useEffect } from 'react';
import '../../css/maindisplay.css';
import Cards from '../main/Cards';
import Leftarrow from '../main/Leftarrow';
import Rightarrow from '../main/Rightarrow';


function MainDisplay(props) {

    // let mainDisplayIntervalCards = props.mainIntervalCards;

    // console.log("main display interval cards")
    // console.log(mainDisplayIntervalCards)

    // startInterval(5000, mainDisplayIntervalCards)

//       setInterval(() => {
//         startInterval(5000, mainDisplayIntervalCards)
//   }, 15000);

    // I want to run startInterval from a button
    // that is in another component (interval).

    //but have that function run in this component:

  // setInterval(() => {
  //   console.log("intervalCards")
  //   console.log(intervalCards)
  // }, 5000);

  // setInterval(() => {
  //   console.log("allCards")
  //   console.log(allCards)
  // }, 5000);


  return (
    <>
      <div id="main-display">

        <Leftarrow selectedLevel={props.selectedLevel}/>
        <Cards selectedLevel={props.selectedLevel} allCards={props.allCards}/>
        <Rightarrow selectedLevel={props.selectedLevel}/>

      </div>
    </>
  )
}

export default MainDisplay;

    
